import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CurrentUserService } from 'src/app/core/services/current-user.service';

/**
 * Lets only admins open the admin page; anyone else lands on the inquiry list. A convenience, not the
 * protection: the API refuses the admin endpoints to everyone without the admin role.
 */
export const adminGuard: CanActivateFn = () => {
  const currentUser = inject(CurrentUserService);
  const router = inject(Router);
  const fallback = router.createUrlTree(['/claim-inquiry']);

  return currentUser.load().pipe(
    map((profile) => (profile.isAdmin ? true : fallback)),
    catchError(() => of(fallback)),
  );
};
